<div (click)="closeModal()" class="modal-close-icon-wrapper">
    <i class="material-icons icon modal-close-icon">
        cancel
    </i>
</div>
<mat-dialog-content class="request-detail-dialog-content">
    <div class="row">
        <div class="col-lg-12"><span class="modal-subtitle">İçerik</span></div>
        <div class="col-lg-12 m-t-5">{{data.description}}</div>
    </div>
    <div class="row m-t-10">
        <div class="col-lg-2 m-t-10" *ngIf="portalDocumentList.length > 0">
            <span class="modal-subtitle">Ekler</span>
        </div>
    </div>
    <div class="row m-t-5" *ngFor="let file of portalDocumentList">
        <div class="col-lg-10 align-self-center">
            <span>{{file.filePath.substr(file.filePath.indexOf("/")+11)}}</span>
        </div>
        <div class="col-lg-2">
            <button class="btn btn-success modal-download-button">
                <a target="_blank" class="modal-download-a" href="{{fileUploadRootPath}}/{{file.filePath}}">
                    İndir
                </a>
            </button>
        </div>
    </div>
</mat-dialog-content>